import { create, v, w } from '@dojo/framework/core/vdom';
import { icache } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
import { Tooltip, Orientation } from '@dojo/widgets/tooltip';
import { Button } from '@dojo/widgets/button';

import css from '../css/progress-tracker.m.css';

interface TopicStatusIconProperties {
	path: string;
	title: string;
	state: boolean;
}

const factory = create({
	icache,
	theme
}).properties<TopicStatusIconProperties>();

export const TopicStatusIcon = factory(({ properties, middleware: { icache, theme } }) => {
	const { path, title, state } = properties();
	const themeCss = theme.classes(css);

	const showTitle = () => icache.set('showTitle', true);
	const hideTitle = () => icache.set('showTitle', false);

	const button = w(Tooltip, { open: icache.getOrSet('showTitle', false), orientation: Orientation.top }, [
		{
			content: title,
			trigger: w(Button, {
				onOver: showTitle,
				onOut: hideTitle,
				onFocus: showTitle,
				onBlur: hideTitle
			})
		}
	]);

	const isCompleted = v('li', { xqa: `completeTGF-${path}`, classes: themeCss.active }, [
		v('div', { classes: themeCss.statusLine }),
		button
	]);
	const isNotCompleted = v('li', { xqa: `incompleteTGF-${path}`, classes: themeCss.notComplete }, [
		v('div', { classes: themeCss.statusLine }),
		button
	]);

	const iconToUse = state ? isCompleted : isNotCompleted;

	return iconToUse;
});

export default TopicStatusIcon;
